import React, { useEffect, useRef } from "react";
import {
  CustomLabel,
  accident_typeOFCOVER,
  adult_select_options,
  ageConditionOfType,
  age_constant,
  age_constant_minus,
  child_select_options,
  female_adult_select_options,
  female_child_select_options,
  gender_select_options,
  initial_selct_options,
  male_adult_select_options,
  male_child_select_options,
  regex_obj,
  si_select_options,
  typeOFCOVER,
  typeOfCal,
} from "../../Constant";
import CustomSelect from "../../elements/CustomSelect";
import { DatePicker, message } from "antd";
import moment from "moment/moment";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../elements/CustomInput";
import {
  onAmountChange,
  onDatePickerChange,
  onGenderChange,
  onRelationshipChange,
  onSIChange,
} from "../../Redux/CIReducer";
import InputComponent from "../InputComponent";

const AgePredict = (date) => {
  if (date == "") return "00";
  //
  let newArr = date.split("/");
  let newDate1 = [newArr[1], newArr[0], newArr[2]];
  let new_date = newDate1.join("/");
  //

  date.split("/").reverse().join("/");
  let newDate = moment().diff(new Date(new_date), "years");
  // if (newDate === 0){
  //   return `${moment().diff(new Date(new_date), "days")} days`
  // }
  // if (`${newDate}` == "NaN"){
  //   return "00"
  // }
  return newDate;
};

const DropdownCardContent = ({
  lable = "Adult",
  num = 0,
  p_data,
  onDataChange,
  user_data_info,
}) => {
  const [data, setData] = React.useState(p_data);
  const typeOfCalculator = useSelector((s) => s.common.type);
  const { adultMember, childMember, coverType } = useSelector((s) => s.CI);

  const dispatch = useDispatch();
  useEffect(() => {
    // dataHandle()
  }, [data]);

  const dateAllowedForChild = (e) => {
    switch (typeOfCalculator) {
      case typeOfCal.ci:
        return (
          e &&
          (e.valueOf() < Date.now() - age_constant_minus["26"] ||
            e.valueOf() > Date.now() - age_constant_minus["19"])
        );

      case typeOfCal.accident_Shield:
        return (
          e &&
          (e.valueOf() < Date.now() - age_constant_minus["26"] ||
            e.valueOf() > Date.now() - age_constant_minus["05"])
        );
    }
  };

  const datePermissible = () => {
    if (lable === "Adult") {
      return moment(Date.now() - age_constant_minus["30"]).format("DD/MM/YYYY");
    } else {
      if (typeOfCalculator === typeOfCal.accident_Shield){
        return moment(Date.now() - age_constant_minus["17"]).format("DD/MM/YYYY");
      }
      return moment(Date.now() - age_constant_minus["19"]).format("DD/MM/YYYY");
    }
  };

  const relationshipData = () => {
    if (num === 1 && lable === "Adult") {
      return initial_selct_options;
    } 
    else if (lable === "Adult" && p_data.gender === "MALE" && num !== 2) {
      const newArr = [...male_adult_select_options];
      newArr.splice(1, 1);
    //  return newArr;
      const newmale_adult_select_options = [
        ...newArr,
      ].filter((ei) => ei.value !== "BROTHER");
      return newmale_adult_select_options;
    } else if (lable === "Adult" && p_data.gender === "FEMALE" && num !== 2) {
      const newArr = [...female_adult_select_options];
      newArr.splice(1, 1);
    //  return newArr;
      const newfemale_adult_select_options = [
        ...newArr,
      ].filter((ei) => ei.value !== "SISTER");
      return newfemale_adult_select_options;
    } 
    else if (
      lable === "Adult" &&
      p_data.gender === "MALE" &&
      typeOfCalculator === typeOfCal.accident_Shield
    ) {
      const newmale_adult_select_options = [
        ...male_adult_select_options,
      ].filter((ei) => ei.value !== "BROTHER");
      return newmale_adult_select_options;
    } else if (
      lable === "Adult" &&
      p_data.gender === "FEMALE" &&
      typeOfCalculator === typeOfCal.accident_Shield
    ) {
      const newfemale_adult_select_options = [
        ...female_adult_select_options,
      ].filter((ei) => ei.value !== "SISTER");
      return newfemale_adult_select_options;
    } else if (
      lable === "Adult" &&
      p_data.gender === "MALE" &&
      typeOfCalculator === typeOfCal.ci
    ) {
      return male_adult_select_options;
    } else if (
      lable === "Adult" &&
      p_data.gender === "FEMALE" &&
      typeOfCalculator === typeOfCal.ci
    ) {
      return female_adult_select_options;
    } else if (
      lable !== "Adult" &&
      p_data.gender === "MALE" &&
      typeOfCalculator === typeOfCal.accident_Shield
    ) {
      const newmale_adult_select_options = [
        ...male_adult_select_options,
      ].filter((ei) => (ei.value === "SON" || ei.value === ""));
      return newmale_adult_select_options;
    } else if (
      lable !== "Adult" &&
      p_data.gender === "FEMALE" &&
      typeOfCalculator === typeOfCal.accident_Shield
    ) {
      const newfemale_adult_select_options = [
        ...female_adult_select_options,
      ].filter((ei) => (ei.value === "DAUGHTER" || ei.value === ""));
      return newfemale_adult_select_options;
    } else if (
      lable !== "Adult" &&
      p_data.gender === "MALE" &&
      typeOfCalculator === typeOfCal.ci
    ) {
      return male_child_select_options;
    } else if (
      lable !== "Adult" &&
      p_data.gender === "FEMALE" &&
      typeOfCalculator === typeOfCal.ci
    ) {
      return female_child_select_options;
    } else if (p_data.gender === "OTHER") {
      return lable === "Adult" ? adult_select_options : child_select_options;
    }
    return initial_selct_options;
  };

  const formatSi = (si) => {
    let dig;
    switch (typeOfCalculator) {
      case typeOfCal.ci:
        dig = si / 100000;
        if (
          p_data.relationship === "SPOUSE" ||
          p_data.relationship === "SELF"
        ) {
          return dig * 0.6 < 1 ? dig * 0.6 : dig * 0.6 > 50 ? 50 : dig * 0.6;
        } else {
          return dig * 0.3 < 1 ? dig * 0.3 : dig * 0.3 > 30 ? 30 : dig * 0.3;
        }
      case typeOfCal.accident_Shield:
        dig = si / 100000;
        if (
          p_data.relationship === "SPOUSE" ||
          p_data.relationship === "SELF"
        ) {
          return dig * 0.6 < 1 ? dig * 0.6 : dig * 0.6 > 50 ? dig * 0.6 : dig * 0.6;
        } else {
          return dig * 0.3 < 1 ? dig * 0.3 : dig * 0.3 > 30 ? 30 : dig * 0.3;
        }
    }
  };

  const siSelectOptions = () => {
    let UPPER_LIMIT;
    switch (typeOfCalculator) {
      case typeOfCal.ci:
        UPPER_LIMIT = (p_data.annualI / 100000) * 10;
        if (UPPER_LIMIT > 2500) {
          UPPER_LIMIT = 2500;
        }
        if (num === 1 && lable === "Adult") {
          return si_select_options({
            uppercap: UPPER_LIMIT,
            type: typeOfCal.ci,
          });
        } else if (coverType === typeOFCOVER.ml) {
          if (p_data.annualI < 10000) {
            return si_select_options({
              uppercap: formatSi(user_data_info.adultData[0]?.si),
              type: typeOfCal.ci,
            }).splice(0, 1);
          } else {
            return si_select_options({
              uppercap: UPPER_LIMIT,
              type: typeOfCal.ci,
            });
          }
        } else if (coverType === typeOFCOVER.ff || coverType === accident_typeOFCOVER.ff) {
          const twoEarningMember = adultMember.filter(
            (ei) => ei.annualI >= 10000
          );
          if (lable === "Adult" && p_data.annualI >= 10000) {
            return si_select_options({
              uppercap: UPPER_LIMIT,
              type: typeOfCal.ci,
            });
          } else if (twoEarningMember.length === 2) {
            let earningMember = adultMember.filter((ei) => ei.annualI >= 10000);
            let BIG_SI =
              parseFloat(earningMember[0]?.si) >
              parseFloat(earningMember[1]?.si)
                ? earningMember[0]?.si
                : earningMember[1]?.si;
            return si_select_options({
              uppercap: formatSi(BIG_SI),
              type: typeOfCal.ci,
            });
          } else {
            return si_select_options({
              uppercap: formatSi(user_data_info.adultData[0]?.si),
              type: typeOfCal.ci,
            });
          }
        } else {
          return si_select_options({
            uppercap: formatSi(user_data_info.adultData[0]?.si),
            type: typeOfCal.ci,
          }).splice(0, 1);
        }
      case typeOfCal.accident_Shield:
        UPPER_LIMIT = (p_data.annualI / 100000) * 20;
        if (UPPER_LIMIT > 2500) {
          UPPER_LIMIT = 2500;
        }
        if (num === 1 && lable === "Adult") {
          return si_select_options({
            uppercap: UPPER_LIMIT,
            type: typeOfCal.accident_Shield,
          });
        } else if (coverType === typeOFCOVER.ml) {
          if (p_data.annualI < 125000) {
            return si_select_options({
              uppercap: formatSi(user_data_info.adultData[0]?.si),
              type: typeOfCal.accident_Shield,
            }).splice(0, 1);
          } else {
            return si_select_options({
              uppercap: UPPER_LIMIT,
              type: typeOfCal.accident_Shield,
            });
          }
        } else if (coverType === typeOFCOVER.ff || coverType === accident_typeOFCOVER.ff) {
          const twoEarningMember = adultMember.filter(
            (ei) => ei.annualI >= 125000
          );
          if (lable === "Adult" && p_data.annualI >= 125000) {
            return si_select_options({
              uppercap: UPPER_LIMIT,
              type: typeOfCal.accident_Shield,
            });
          } else if (twoEarningMember.length === 2) {
            let earningMember = adultMember.filter(
              (ei) => ei.annualI >= 125000
            );
            let BIG_SI =
              parseFloat(earningMember[0]?.si) >
              parseFloat(earningMember[1]?.si)
                ? earningMember[0]?.si
                : earningMember[1]?.si;
            return si_select_options({
              uppercap: formatSi(BIG_SI),
              type: typeOfCal.accident_Shield,
            });
          } else {
            return si_select_options({
              uppercap: formatSi(user_data_info.adultData[0]?.si),
              type: typeOfCal.accident_Shield,
            });
          }
        } else {
          return si_select_options({
            uppercap: formatSi(user_data_info.adultData[0]?.si),
            type: typeOfCal.accident_Shield,
          }).splice(0, 1);
        }
    }
  };

  const warning = () => {
    if (lable === "Adult" && AgePredict(data.dob) > 0) {
      return ageConditionOfType(
        typeOfCalculator,
        AgePredict(data.dob),
        user_data_info.adult
      );
      // return parseInt(AgePredict(data.dob)) > 65;
    }
  };
  /**
   *
   * @param {
   *
   * } type
   * @param {*} e stands for the value
   * @param {*} pos stands for position of the array
   * 1) adult
   * 2) adult
   * 3)
   */

  const dataHandle = (type, e, pos) => {
    switch (type) {
      case "dob":
        dispatch(onDatePickerChange({ type: lable, value: e, pos: num - 1 }));
        break;
      case "gender":
        dispatch(onGenderChange({ type: lable, value: e, pos: num - 1 }));
        break;
      case "relationship":
        dispatch(onRelationshipChange({ type: lable, value: e, pos: num - 1 }));
        break;
      case "amt":
        dispatch(onAmountChange({ type: lable, value: e, pos: num - 1 }));
        break;
      case "si":
        dispatch(onSIChange({ type: lable, value: e, pos: num - 1 }));
        break;
    }
  };

  return (
    <div className="dob-detail-box">
      <CustomLabel font_size="12" color="#b2b2b2">
        {lable} 0{`${num}`} Age {data.dob}
      </CustomLabel>
      <div className="row gy-2">
        <div className="col-6">
          {data.dob == "" ? (
            // <DatePicker
            //   allowClear={true}
            //   style={{ width: "100%" }}
            //   defaultPickerValue={dayjs(datePermissible(), "DD/MM/YYYY")}
            //   placement={"bottom"}
            //   onChange={(_, e) => {
            //     setData({ ...data, dob: e });
            //     setTimeout(() => {
            //       dataHandle("dob", e, num);
            //     }, 200);
            //   }}
            //   disabledDate={(e) => {
            //     if (lable === "Adult") {
            //       if (
            //         ["son", "sister", "brother", "daughter"].includes(
            //           p_data.relationship.toLowerCase()
            //         ) &&
            //         typeOfCalculator === typeOfCal.ci
            //       ) {
            //         return (
            //           e &&
            //           (e.valueOf() < Date.now() - age_constant_minus["26"] ||
            //             e.valueOf() > Date.now() - age_constant_minus["19"])
            //         );
            //       } else if (
            //         ["son", "daughter"].includes(
            //           p_data.relationship.toLowerCase()
            //         ) &&
            //         typeOfCalculator === typeOfCal.accident_Shield
            //       ) {
            //         return (
            //           e &&
            //           (e.valueOf() < Date.now() - age_constant_minus["26"] ||
            //             e.valueOf() > Date.now() - age_constant_minus["19"])
            //         );
            //       }
            //       return (
            //         e && e.valueOf() > Date.now() - age_constant_minus["19"]
            //       );
            //     } else {
            //       return dateAllowedForChild(e);
            //     }
            //   }}
            //   showToday={false}
            //   format="DD/MM/YYYY"
            // />

            <InputComponent
            placeholder="Enter Age"
            value={data.dob}
            onChange={ (e) => {
               setData({ ...data, dob: e.target.value });
              setTimeout(()=>{
                dataHandle("dob", e.target.value )
              },1000) ;
            }}
            maxLength={2}
            isAgeInput= {true}
          />

          ) : (
            // <DatePicker
            //   status={warning() && "error"}
            //   allowClear={true}
            //   value={dayjs(data.dob, "DD/MM/YYYY")}
            //   placement={"bottom"}
            //   onChange={(_, e) => {
            //     setData({ ...data, dob: e });
            //     setTimeout(() => {
            //       dataHandle("dob", e);
            //     }, 200);
            //   }}
            //   disabledDate={(e) => {
            //     if (lable === "Adult") {
            //       if (
            //         ["son", "sister", "brother", "daughter"].includes(
            //           p_data.relationship.toLowerCase()
            //         ) &&
            //         typeOfCalculator === typeOfCal.ci
            //       ) {
            //         return (
            //           e &&
            //           (e.valueOf() < Date.now() - age_constant_minus["26"] ||
            //             e.valueOf() > Date.now() - age_constant_minus["19"])
            //         );
            //       } else if (
            //         ["son", "daughter"].includes(
            //           p_data.relationship.toLowerCase()
            //         ) &&
            //         typeOfCalculator === typeOfCal.accident_Shield
            //       ) {
            //         return (
            //           e &&
            //           (e.valueOf() < Date.now() - age_constant_minus["26"] ||
            //             e.valueOf() > Date.now() - age_constant_minus["19"])
            //         );
            //       }
            //       return (
            //         e && e.valueOf() > Date.now() - age_constant_minus["19"]
            //       );
            //     } else {
            //       return dateAllowedForChild(e);
            //     }
            //   }}
            //   showToday={false}
            //   format="DD/MM/YYYY"
            // />

                    <InputComponent
                        placeholder="Enter Age"
                        value={data.dob}
                        onChange={ (e) => {
                           setData({ ...data, dob: e.target.value });
                          setTimeout(()=>{
                            dataHandle("dob", e.target.value )
                          },1000) ;
                        }}
                        maxLength={2}
                        isAgeInput= {true}
                      />
          )}
        </div>
        <div className="col-6">
          <CustomSelect
            defaultValue={p_data.gender}
            options={gender_select_options}
            onChange={(e) => {
              setData({ ...data, gender: e.target.value });
              setTimeout(() => {
                dataHandle("gender", e.target.value);
              }, 200);
            }}
          />
        </div>
        <div className="col-6">
          <CustomSelect
            defaultValue={p_data.relationship}
            disabled={
              lable === "Adult"
                ? adultMember[num - 1]?.gender === ""
                : childMember[num - 1]?.gender === ""
            }
            options={relationshipData()}
            onChange={(e) => {
              setTimeout(() => {
                dataHandle("relationship", e.target.value);
              }, 200);
            }}
          />
        </div>
        <div className="col-6">
          <CustomInput
            label={""}
            disabled={
              lable === "Adult"
                ? adultMember[num - 1]?.relationship === "" ||
                  ((coverType === typeOFCOVER.ff || coverType === accident_typeOFCOVER.ff) &&
                    adultMember[num - 1]?.relationship !== "SPOUSE" &&
                    adultMember[num - 1]?.relationship !== "SELF")
                : true
            }
            regex={regex_obj.income_number}
            placeholder="Annual Income"
            value={
              lable === "Adult"
                ? adultMember[num - 1]?.annualI
                : childMember[num - 1]?.annualI
            }
            onChange={(e) => {
              dataHandle("amt", e.target.value);
            }}
            showError={false}
            maxLength={8}
            readOnly={false}
          />
        </div>
        <div className="col-6">
          <CustomSelect
            // disabled={
            //   lable === "Adult"
            //     ? adultMember[num - 1]?.annualI < 1
            //     : childMember[num - 1]?.annualI < 1
            // }
            defaultValue={p_data.si}
            options={siSelectOptions()}
            onChange={(e) => {
              dataHandle("si", e.target.value);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(DropdownCardContent);
